<template>
  <!-- 头部整体盒子 -->
  <div id="header">
    <div class="page-head border-box" :class="headerState==1?'curr':''">
      <div class="head-blur"></div>
      <router-link to="/">
        <img class="fl logo" src="../assets/img/logo.png" alt="新希望乳业" @click="navClick(0,'首页')">
      </router-link>
      <ul class="fl nav-box">
        <li class="fl nav-item"  v-for="(item,index) in navList" :key="index" :data-ind="index"
        :class="index==navIndex?'active':''" @click="navClick(index,item.name)" data-toggle="collapse" data-target="#menu">
          <router-link class="router" :to="item.path">
          {{item.name}}
            <!--<span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>-->
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n"  @click="navClick(index,item.name)">
              <a :href="i.path" target="_blank" v-if="i.isOutlink">{{i.name}}</a>
              <router-link :to="i.path" v-else>{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
      <div class="fr icon-box">
        <div class="fl icon clearfix">
          <img src="../assets/img/icon-wechat.png" alt="">
          <span class="ewm-box">
            <img src="../assets/img/ewm.png" alt="">
          </span>
        </div>
        <a class="fl icon clearfix" href="https://weibo.com/xinxiwangruye" target="_blank">
          <img src="../assets/img/icon-sina.png" alt="">
        </a>
      </div>
      <div class="menu-bar" :class="sPageShow==1?'curr':''" @click="sPageShowFun">
        <span class="line l1 tran2s"></span>
        <span class="line l2 tran2s"></span>
        <span class="line l4 tran2s"></span>
        <span class="line l3 tran2s"></span>
      </div>
    </div>

    <div class="s-page-head box" v-if="sPageShow==1">
      <div class="left">
        <div class="left-item" v-for="(item,index) in navList" :key="index" :data-ind="index"
             :class="index==navIndex?'active':''" @click="navClick(index,item.name)" data-toggle="collapse" data-target="#menu">
          <router-link class="router" :to="item.path">
            {{item.name}}
            <!--<span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>-->
          </router-link>
        </div>
      </div>
      <div class="flex right">
        <div class="right-item" v-for="(item,index) in navList[navIndex].children" :key="index" :data-ind="index" v-if="navList[navIndex].children.length>0"  @click="sPageShow=0">
          <a :href="item.path" target="_blank" v-if="item.isOutlink">{{item.name}}</a>
          <router-link :to="item.path" v-else>{{item.name}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "关于新希望",
          path: "/about-group",
          children: [
            {
              name: "新希望集团",
              path: "/about-group"
            },
            {
              name: "新希望乳业",
              path: "/about-dairy"
            },
            {
              name: "布局·历程",
              path: "/about-layout"
            },
            {
              name: "企业荣誉",
              path: "/about-honor"
            },
            {
              name: "科研成果",
              path: "/about-science"
            },
            {
              name: "企业文化",
              path: "/about-culture"
            }
          ]
        },
        {
          name: "品牌活动",
          path: "/brand-choice",
          children: [
            {
              name: "新鲜一代的选择",
              path: "/brand-choice"
            },
            {
              name: "优质乳产业链",
              path: "/brand-industryChain"
            },
            {
              name: "新鲜盛典",
              path: "/brand-forum"
            },
            {
              name: "食育乐园",
              path: "/brand-paradise"
            },
            {
              name: "牛奶粉丝节",
              path: "/brand-fanFestival"
            }
          ]
        },
        {
          name: "鲜活产品",
          path: "/product-home",
          children: [
//            {
//              name: "新版初心",
//              path: "/product?tab=heart"
//            },
//            {
//              name: "特色单品",
//              path: "/product1?tab=single"
//            }
          ]
        },
        {
          name: "新鲜资讯",
          path: "/news?tab=0",
          children: [
            {
              name: "新鲜FANS",
              path: "/news?tab=0"
            },
            {
              name: "媒体窗口",
              path: "/news1?tab=1"
            },
            {
              name: "Hi，新乳业",
              path: "/news2?tab=2"
            }
          ]
        },
        {
          name: "投资者关系",
          path: "/investor?tab=3",
          children: [
            {
              name: "股票动态",
              path: "/investor?tab=3"
            },
            {
              name: "最新公告",
              path: "/investor0?tab=0"
            },
            {
              name: "定期报告",
              path: "/investor1?tab=1"
            },
            {
              name: "公司治理",
              path: "/investor2?tab=2"
            },
            {
              name: "投资者关系",
              path: "https://ir.p5w.net/c/002946.shtml",
              isOutlink: true
            }
          ]
        },
        {
          name: "可持续发展",
          path: "/develop-info",
          children: [
            {
              name: "可持续发展",
              path: "/develop-info"
            },
            {
              name: "希望有你",
              path: "/develop-withyou"
            },
//            {
//              name: "社会责任",
//              path: "/develop-respons"
//            },
//            {
//              name: "绿色环保",
//              path: "/develop-green"
//            }
          ]
        },
        {
          name: "科技创新",
          path: "/technical-innovation",
          children: [
            {
              name: "智慧牧场",
              path: "/technical-innovation"
            },
            {
              name: "数字工厂",
              path: "/technical-digital"
            },
            {
              name: "科技研发",
              path: "/technical-research"
            },
            {
              name: "营销数字化",
              path: "/technical-marketing"
            }
          ]
        },
        {
          name: "加入我们",
          path: "/join-us",
          children: [
            {
              name: "招聘",
              path: "/join-us"
            },
//            {
//              name: "HR信箱",
//              path: "/join-us?alertShow=1"
//            },
            {
              name: "联系我们",
              path: "/join-map"
            }
          ]
        }
      ],
      sPageShow:0
    };
  },
  props:['headerState'],
  mounted() {
    var self = this;
    setTimeout(function(){
      self.navIndex = sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0;
      self.navIndex = self.$route.name;
    },200)
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index);
      this.menuName = name;
      window._czc.push(['_trackEvent', '头部菜单', '点击菜单跳转页面']);
    },

    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },

    sPageShowFun(){
      var self =this;
      if(self.sPageShow==1){
        self.sPageShow = 0;
      }else{
        self.sPageShow = 1;
      }
    }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue